import React from 'react';

const TickIcon = ({ color = "white" }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M9.75003 15.8359L19.543 6.04346L20.9571 7.4577L10.4571 17.9572C10.0666 18.3477 9.43349 18.3477 9.04297 17.9573L3.79297 12.7077L5.20712 11.2934L9.75003 15.8359Z" fill={color} />
        </svg>
    );
}

export default TickIcon;